module.exports = __webpack_public_path__ + "static/img/basketball.5bef403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basketball.png
// module id = ycsn
// module chunks = 20